import React, { useEffect, useState } from "react";
import { $host } from "../../../../http";
import TestCard from "../../components/cards/TestCard";
import CreateTestModal from "../../components/modal/CreateTestModal";
import TestActionsModal from "../../components/modal/TestActionsModal";

const Tests = () => {
    const [courses, setCourses] = useState([]);
    const [paragraphs, setParagraphs] = useState([]);
    const [themes, setThemes] = useState([]);
    const [homeworks, setHomeworks] = useState([]);

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedParagraph, setSelectedParagraph] = useState(null);
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isHomeworkModalOpen, setIsHomeworkModalOpen] = useState(false);
    const [currentHomework, setCurrentHomework] = useState(null);
    const [createThemeId, setCreateThemeId] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const coursesRes = await $host.get("/api/teachers/courses", { withCredentials: true });
            setCourses(coursesRes.data || []);

            const paragraphsRes = await $host.get("/api/teachers/paragraphs", { withCredentials: true });
            setParagraphs(paragraphsRes.data || []);

            const themesRes = await $host.get("/api/teachers/themes", { withCredentials: true });
            setThemes(themesRes.data.map(t => ({ ...t, id: String(t.id) })));

            const homeworksRes = await $host.get("/api/teachers/homeworks", { withCredentials: true });
            setHomeworks(homeworksRes.data.map(h => ({ ...h, theme_id: String(h.theme_id) })));

        } catch (error) {
            console.error("Ошибка загрузки данных:", error.message);
        }
    };

    const handleDeleteHomework = async (homeworkId) => {
        try {
            await $host.delete(`/api/teachers/homeworks/${homeworkId}`, { withCredentials: true });
            setHomeworks((prev) => prev.filter((homework) => homework.id !== homeworkId));
        } catch (error) {
            console.error("Ошибка удаления домашнего задания:", error.message);
        }
    };

    const handleCreateHomework = () => {
        setCreateThemeId(selectedTheme || null);
        setIsCreateModalOpen(true);
    };

    const handleSaveHomework = (newHomework) => {
        setHomeworks((prev) => [...prev, newHomework]);
    };

    const handleHomeworkClick = (homework) => {
        setCurrentHomework(homework);
        setIsHomeworkModalOpen(true);
    };

    // Фильтрация домашних заданий по курсу, параграфу, теме и поиску
    const filteredHomeworks = homeworks.filter((homework) => {
        const theme = themes.find((t) => t.id === homework.theme_id);
        const paragraph = paragraphs.find((p) => p.id === theme?.paragraph_id);

        return (
            (!selectedCourse || paragraph?.course_id === selectedCourse) &&
            (!selectedParagraph || theme?.paragraph_id === selectedParagraph) &&
            (!selectedTheme || homework.theme_id === selectedTheme) &&
            (!searchQuery || theme?.title.toLowerCase().includes(searchQuery.toLowerCase()))
        );
    });

    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-4">Список домашних заданий</h2>

            {/* Фильтры */}
            <div className="flex flex-wrap gap-4 mb-4">
                <select
                    className="border p-2 rounded-md"
                    onChange={(e) => {
                        setSelectedCourse(e.target.value);
                        setSelectedParagraph(null);
                        setSelectedTheme(null);
                    }}
                    value={selectedCourse || ""}
                >
                    <option value="">Выберите курс</option>
                    {courses.map((course) => (
                        <option key={course.id} value={course.id}>
                            {course.title}
                        </option>
                    ))}
                </select>

                <select
                    className="border p-2 rounded-md"
                    disabled={!selectedCourse}
                    onChange={(e) => {
                        setSelectedParagraph(e.target.value);
                        setSelectedTheme(null);
                    }}
                    value={selectedParagraph || ""}
                >
                    <option value="">Выберите параграф</option>
                    {paragraphs
                        .filter((p) => p.course_id === selectedCourse)
                        .map((paragraph) => (
                            <option key={paragraph.id} value={paragraph.id}>
                                {paragraph.title}
                            </option>
                        ))}
                </select>

                <select
                    className="border p-2 rounded-md"
                    disabled={!selectedParagraph}
                    onChange={(e) => setSelectedTheme(e.target.value)}
                    value={selectedTheme || ""}
                >
                    <option value="">Выберите тему</option>
                    {themes
                        .filter((t) => t.paragraph_id === selectedParagraph)
                        .map((theme) => (
                            <option key={theme.id} value={theme.id}>
                                {theme.title}
                            </option>
                        ))}
                </select>

                {/* Поле поиска по названию темы */}
                <input
                    type="text"
                    className="border p-2 rounded-md w-64"
                    placeholder="Поиск по названию темы..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />

                <button
                    className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 transition"
                    onClick={handleCreateHomework}
                >
                    + Создать домашнее задание
                </button>
            </div>

            {/* Отображение домашних заданий */}
            <div className="flex flex-col gap-2">
                {filteredHomeworks.map((homework) => (
                    <TestCard
                        key={homework.id}
                        homework={homework}
                        themes={themes}
                        onDelete={handleDeleteHomework}
                        onClick={() => handleHomeworkClick(homework)}
                    />
                ))}
            </div>

            {/* Модалки */}
            <CreateTestModal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                onSave={handleSaveHomework}
                initialThemeId={createThemeId}
                courses={courses}
                paragraphs={paragraphs}
                themes={themes}
            />
            {currentHomework && (
                <TestActionsModal
                    isOpen={isHomeworkModalOpen}
                    onClose={() => setIsHomeworkModalOpen(false)}
                    homework={currentHomework}
                />
            )}
        </div>
    );
};

export default Tests;
